<template>
  <div>
    <ReactWrapper :react-component="reactComponent" />
  </div>
</template>

<script lang="ts">
import HeroProviderBasic from "@iloq/shared-react/frontpage/hero-provider-basic";
import HeroProviderPartner from "@iloq/partner-program/frontpage/hero-provider-partner";
import { defineComponent } from "vue";
import ReactWrapper from "../util/ReactWrapper.vue";
import { mapState } from "vuex";
import { IPartnerInfoState } from "@iloq/shared/IRootState";
import { PartnerTier } from "@iloq/shared/IPartnerInfo";

export default defineComponent({
  name: "FrontpageHeroConnector",
  components: {
    ReactWrapper,
  },
  computed: {
    ...mapState("partnerInfo", {
      reactComponent: (state: unknown) => {
        const tier = (state as IPartnerInfoState).partnerInfo.partnerTier;
        if (!tier || tier === PartnerTier.NONE) {
          return HeroProviderBasic;
        }
        return HeroProviderPartner;
      },
    }),
  },
});
</script>
